export default "__VITE_ASSET__CPwhQGf3__"